import React, { useContext, useEffect, useState } from 'react'
import { Col, Form } from 'react-bootstrap'
import { useFetch } from '../../hooks'
import { FormSelectFilter } from '../../components/molecules'
import ClienteSelect from '../../components/molecules/ClienteSelect'
import { WButton } from '../../components/atoms'
import { Card, CardBody, CardHeader, Row } from 'reactstrap'
import { volumeReportFilterDataContext } from '../../HOC/volumeReportFiltersContext'

function VolumeFilterForm() {
  const [name, setName] = useState('')
  const [locale, setLocale] = useState('')
  const [nameFilter, setNameFilter] = useState('')
  const [selectedClientId, setSelectedClientId] = useState('')
  const [hasPendingNameApply, setHasPendingNameApply] = useState(false)
  const [filteredNames, setFilteredNames] = useState([])

	const clienti = useFetch({ url: 'clienti/' })
	const countries = useFetch({ url: 'volume-report-scheduled/countries/' })
	const namesList = useFetch({ url: 'volume-report-scheduled/names/' })

  const [, , getFilteredData, , , setActualPage] = useContext(volumeReportFilterDataContext)

  const buildNextNameFilter = (rawName) => {
    const normalizedName = rawName.trim()
    if (!normalizedName) {
      return nameFilter
    }

    return normalizedName
  }

  useEffect(() => {
    if (!namesList?.data) {
      setFilteredNames([])
      return
    }

    const query = name.trim().toLowerCase()
    if (!query) {
      setFilteredNames([])
      return
    }

    setFilteredNames(
      namesList.data
        .filter(
          (option) => option.toLowerCase().includes(query) && option.toLowerCase() !== nameFilter.toLowerCase()
        )
        .slice(0, 10)
    )
  }, [name, nameFilter, namesList?.data])

  const commitDraftName = () => {
    const nextNameFilter = buildNextNameFilter(name)
    setNameFilter(nextNameFilter)
    setName('')
    return nextNameFilter
  }

  const handleClearFilters = () => {
    setActualPage(1)
    setName('')
    setSelectedClientId('')
    setLocale('')
    setNameFilter('')
    setHasPendingNameApply(false)
    setFilteredNames([])
    getFilteredData({ page_size: 10, page: 1 })
  }

  const handleApplyFilters = () => {
    const nextNameFilter = commitDraftName()

    setActualPage(1)
    const params = {
      ...(nextNameFilter.length > 0 && { name: nextNameFilter }),
      ...(selectedClientId.length > 0 && { cliente: selectedClientId }),
      ...(locale.length > 0 && { locale: locale }),
      page_size: 10,
      page: 1,
    }
    setHasPendingNameApply(false)
    getFilteredData(params)
  }

  const handleNameKeyDown = (event) => {
    if (event.key !== 'Enter') {
      return
    }

    event.preventDefault()
    commitDraftName()
    setHasPendingNameApply(true)
  }

  const handleSuggestionClick = (suggestedName) => {
    setNameFilter(buildNextNameFilter(suggestedName))
    setName('')
    setFilteredNames([])
    setHasPendingNameApply(false)
  }

  const handleRemoveNameFilter = () => {
    setNameFilter('')
    setHasPendingNameApply(false)
  }

  return (
    <>
      {clienti && countries && (
        <div className="pb-8 pt-5 pt-md-8">
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <h1 className="mb-0">Filters</h1>
                </CardHeader>
                <CardBody className="pt-0">
                  <Form>
                    <Row
                      className="justify-content-center"
                      style={{ marginLeft: '80px', marginRight: '80px' }}
                    >
                      <Col>
                        <Form.Group className="market-screener-name-filter">
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            autoComplete="off"
                            placeholder="Name"
                            value={name}
                            onChange={(event) => setName(event.target.value)}
                            onKeyDown={handleNameKeyDown}
                          />
                          {hasPendingNameApply && nameFilter.length > 0 && (
                            <small className="form-text text-muted">
                              Premi Apply per confermare il filtro corrente.
                            </small>
                          )}
                          {filteredNames.length > 0 && (
                            <ul className="suggestions-list mt-2">
                              {filteredNames.map((suggestedName) => (
                                <li
                                  key={suggestedName}
                                  className="suggestion-item"
                                  onMouseDown={(event) => event.preventDefault()}
                                  onClick={() => handleSuggestionClick(suggestedName)}
                                >
                                  {suggestedName}
                                </li>
                              ))}
                            </ul>
                          )}
                          {nameFilter.length > 0 && (
                            <div className="market-screener-active-filters">
                              <ul className="market-screener-filter-tags">
                                <li key={nameFilter} className="market-screener-filter-tag">
                                  <span>{nameFilter}</span>
                                  <button
                                    type="button"
                                    className="market-screener-filter-tag__remove"
                                    onClick={handleRemoveNameFilter}
                                  >
                                    x
                                  </button>
                                </li>
                              </ul>
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col>
                        <ClienteSelect
                          id="market-screener-cliente-filter"
                          label="Cliente"
                          clienti={clienti.data || []}
                          selectedClientId={selectedClientId}
                          onChange={setSelectedClientId}
                          placeholder="Filtra per cliente"
                          isClearable
                        />
                      </Col>
                      <Col>
                        <FormSelectFilter
                          label={'Country'}
                          value={locale}
                          onChange={setLocale}
                          data={countries.data}
                        />
                      </Col>
                    </Row>
                  </Form>
                  <Row style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '92px' }}>
                    <WButton label="Clear Filters" variant="light" onClick={handleClearFilters} />
                    <WButton label="Apply" variant="primary" onClick={handleApplyFilters} />
                  </Row>
                </CardBody>
              </Card>
            </div>
          </Row>
        </div>
      )}
    </>
  )
}
export default VolumeFilterForm
